import styled from '@emotion/styled';

export const SadaKRefColumn = styled.div``;
